import JSZip from 'jszip'
import { BLOCKED_DOCUMENTS, LABEL_FILE_TYPE } from '../constants/applications'

export const zipDownload = async (
  filesForDownload = [],
  folderName,
  $axios
) => {
  const zip = new JSZip()
  const p = filesForDownload.map(async (filesForDownload) => {
    const promises = filesForDownload.map(async (file, index) => {
      if (!BLOCKED_DOCUMENTS.includes(file.purpose)) {
        const response = await $axios({
          method: 'get',
          url: file.path,
          responseType: LABEL_FILE_TYPE,
        })
        const headers = response.headers
        const contentType = headers['content-type']
        let extensionFromContentType = ''
        let isImageType = false
        if (contentType) {
          const arr = contentType.split('/')
          isImageType = arr[0] === 'image'
          extensionFromContentType = arr[1]
        }
        const fileName = file.name?.split('.').slice(0, -1).join('.')
        const extension = isImageType
          ? extensionFromContentType ||
            file.name.substring(file.name.lastIndexOf('.') + 1)
          : file.name.substring(file.name.lastIndexOf('.') + 1)
        const blob = new Blob([response.data], {
          type: contentType,
        })
        file.purpose = file.purpose.replaceAll('/', '-')
        return {
          folder: `${file.label}/${file.purpose}`,
          fileName: `${fileName}-${index}.${extension}`,
          blob: blob,
        }
      }
    })
    const contents = await Promise.all(promises)
    let hasContent = false
    contents.forEach((content) => {
      if (content) {
        hasContent = true
        zip.folder(content.folder).file(content.fileName, content.blob, {
          binary: true,
        })
      }
    })
    if (hasContent) {
      const content = await zip.generateAsync({ type: 'blob' })
      const objectUrl = URL.createObjectURL(content)
      const link = document.createElement('a')
      link.download = `${folderName.firstName}-${folderName.lastName}-${folderName.shortId}`
      link.href = objectUrl
      link.click()
    }
  })
  await Promise.all(p)
}
